import transformConstants from './transform';

const transformedClientConstants = transformConstants(process.env);

const constants = {
  ...transformedClientConstants,
  AUTH_TOKEN: 'AUTH_TOKEN',
  BASE_URL: process.env.PUBLIC_URL ? new URL(process.env.PUBLIC_URL).pathname : '',
  DEFAULT_URL: process.env.PUBLIC_URL,
};

export const {
  AUTH_TOKEN,
  BASE_URL,
  DEFAULT_URL,
  EMBED_URL,
  API_URL,
  SENTRY_ENVIRONMENT,
  GQL_HOST,
  TRANSACTION_ID,
} = constants;
